import { Etapa } from '../../../models/etapa';
import { EtapaService } from '../../../services/etapa.service';
import { IpPublicService } from '../../../../../services/ip-public.service';
import { Component, OnDestroy, OnInit, ViewChild, Input } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { AlertService } from '../../../../../services/alert.service';
import { ModalService } from '../../../../../services/modal.service';
import { DataTableDirective } from 'angular-datatables';
import { EspecialUnoService } from 'src/app/modulos/catalogos-proces/services/especial-uno.service';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { HitoService } from '../../../services/hito.service';
import { UsuarioRedux } from 'src/app/models/usuario.model';

@Component({
  selector: 'app-etapa',
  templateUrl: './etapa.component.html',
  styleUrls: ['./etapa.component.css'],
})
export class EtapaComponent implements OnInit, OnDestroy {
  public formEtapa: UntypedFormGroup;
  public currentUserRedux: UsuarioRedux = null;
  public formSubmitted = false;
  public currentAmbiente: any;
  public ipAddress!: string;
  public buffer: any;
  public dataEtapa: any[] = [];
  public dataCatalogoEtapaProyecto!: any;
  public dataProyecto!: any;
  private idDeleteRegister: number = 0;
  public selectItems: any[] = [];
  public nameModalEtapa: string = 'etapa-hito';
  public editNameModalEtapa: string = 'editar-Etapa-hito';
  public nameModal1: string = 'HITOS';
  public nameEtapa = 'ETAPA';
  public idSprProyecto!: 0;
  public idSprUsuario!: number;
  public hito = [];
  public idSprNivel: number = 0;
  public desripcionEtapa!: any;
  public maximoHitosEtapa!: number;
  public descripcionProyecto = 0;
  public idEtapa!: number;
  public dataEtapaProyecto: any;
  public idSprEspecialUnoEtapaProyectos = ConstantsCatalogosIdService.ID_ESPECIAL_UNO_ETAPA_PROYECTO;
  readonly constant = ConstantsCatalogosIdService;
  public idSprProyectoSeleccionado: any;
  public proyectoInput: any = null;
  titulosEtapa: any[] = [];
 
  catalogoEtapas: string[] = [
    '1.Anteproyecto',
    '2.Definición',
    '3.Planificación',
  ];
  ordenesEtapas: {
    id: number;
    numero: number;
    nombre: string;
    orden: number;
  }[] = [];
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  hoy = new Date();
  pipe = new DatePipe('en-US');

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  isDtInitialized: boolean = false;

  @Input() set data(Proyectos: any) {
    this.idSprProyecto = Proyectos.idSprProyecto;
    this.descripcionProyecto = Proyectos.nombreProyecto;
    if (this.idSprProyecto) {
      this.initApp();
    }
  }

  @Input() set proyecto(proyectoActual: any) {
    this.proyectoInput = proyectoActual;
  }


  constructor(
    private fb: FormBuilder,
    private etapaService: EtapaService,
    private alertService: AlertService,
    private ip: IpPublicService,
    public modal: ModalService,
    private especialUnoService: EspecialUnoService,
    private hitoService: HitoService,
    private store: Store<AppState>
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentAmbiente = JSON.parse(this.buffer);
    this.selectItems = [
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    this.titulosEtapa = [{
      nombre: '',
    }];
  }

  get etapaForm() {
    return this.formEtapa.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  initApp() {
    this.listDataEtapa();
    this.setDataTable();
    this.setForm();
  }

  ngOnInit(): void {
    this.store.select('globalApp').subscribe((response) => {
    this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
    });
    this.getIpPublic();
    this.initApp();
    this.ordenesEtapas = this.getOrdenesEtapas();
    this.ordenesEtapas.sort((a, b) => a.orden - b.orden);
    this.store.select('usuarioApp').subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuario = response.currentUser.idSprUsuario;
    });
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
    this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onSelectEtapa(etapas: any[]) {
    let etapaSeleccionada = etapas.filter(
      (etapa) =>
        etapa.idSprEspecialUno === +this.formEtapa.value.idSprEtapaProyecto
    )[0];
    this.formEtapa.patchValue({
      ...this.formEtapa.value,
      pesoTotal: +etapaSeleccionada.ponderacion,
    });
  }

  setForm() {
    this.formEtapa = this.fb.group({
      idSprEtapa: [],
      idSprProyecto: [this.idSprProyecto],
      idSprEtapaProyecto: ['', [Validators.required]],
      maximoHitos: ['', [Validators.required]],
      orden: [''],
      pesoTotal: ['', [Validators.required]],
      fechaInicio: [this.pipe.transform(this.hoy, 'yyyy-MM-dd')],
      fechaFin: [this.pipe.transform(this.hoy, 'yyyy-MM-dd')],
      estado: [1, [Validators.required]],
    });
  }

  onSubmit() {
    this.formSubmitted = true;
    this.formEtapa.value.idSprProyecto = this.idSprProyecto;
    this.formEtapa.value.usuario = this.idSprUsuario;
    this.formEtapa.value.ip = this.ipAddress;
    if (this.formEtapa.valid) {
      // Realizar el posteo
      if (!this.formEtapa.value.idSprEtapa) {
        // Obtener detalles específicos del proyecto
        this.etapaService.list(`?idSprProyecto=${this.formEtapa.value.idSprProyecto}`)
          .subscribe(
            (proyectoDetails) => {
              // Obtener información de especialUnoService
              this.especialUnoService.list(`${this.formEtapa.value.idSprEtapaProyecto}`)
                .subscribe({
                  next: (resp) => {
                    let nombre = resp.nombre;
                    const numeroExtraido = nombre.match(/\d+/);
                    const ordenNuevaEtapa = parseInt(numeroExtraido[0], 10);
                    // Obtener el orden de la última etapa creada
                    const ultimoOrden = proyectoDetails.reduce(
                      (max, etapa) => Math.max(max, etapa.orden),
                      0
                    );
                    if (ordenNuevaEtapa === ultimoOrden + 1 &&
                      proyectoDetails.length <= 5) {
                      // Crear nueva etapa
                      this.formEtapa.value.orden =ordenNuevaEtapa;
                      this.etapaService.create(this.formEtapa.value).subscribe(
                        (resp) => {
                          this.closeModalEtapa();
                          this.alertService.createOk();
                          this.initApp();
                        },
                        (err) => {
                          this.alertService.createError();
                        }
                      );
                    } else {
                      if (proyectoDetails.length >= 5) {
                        this.alertService.warning(
                          '¡Atención!',
                          'No se pueden agregar más de cinco etapas.'
                        );
                      } else {
                        this.alertService.warning(
                          '¡Atención!',
                          `La nueva etapa debe ser la número ${ultimoOrden + 1}`
                        );
                      }
                    }
                  },
                  error: (error) => {
                    // Manejar el error al obtener información de especialUnoService
                    this.alertService.error( 'Error al obtener información de especialUnoService:');
                  },
                }); //aqui es el final de copia
            },
            (error) => {
              // Manejar el error al obtener detalles del proyecto
              this.alertService.error( 'Error al obtener detalles del proyecto:');
            }
          );
      } else {
          // Realizar la lógica de edición aquí         
          this.etapaService.update(this.formEtapa.value)
            .subscribe(
              (resp) => {
                this.closeModalEtapaEdit();
                this.alertService.createOk();
                this.initApp();
              },
              (err) => {
                this.alertService.createError();
              }
            );
      }
      return true;
    } else {
      return false;
    }
  }

  getOrdenesEtapas(): {
    id: number;
    numero: number;
    nombre: string;
    orden: number;
  }[] {
    const ordenesEtapas = this.catalogoEtapas.map((etapa) => {
      const [numero, nombre] = etapa.split('.'); // Dividir la cadena en número y nombre
      return {
        id: parseInt(numero), // Convertir el número a entero (si es necesario)
        numero: parseInt(numero),
        nombre: nombre.trim(), // Eliminar espacios adicionales
        orden: parseInt(numero), // Usar el número como orden
      };
    });
    return ordenesEtapas;
  }

  update(obj: Etapa) {
    this.viewDataConfig(obj.idSprEtapaProyecto)
    this.openModalEtapaEdit();
    this.formEtapa.patchValue({
      idSprEtapa: obj.idSprEtapa,
      idSprProyecto: obj.idSprProyecto,
      idSprEtapaProyecto: obj.idSprEtapaProyecto,
      maximoHitos: obj.maximoHitos,
      orden:obj.orden,
      pesoTotal: obj.pesoTotal,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      estado: obj.estado,
    });
  }

  ////////////////VALIDACIÓN DE NO CREAR LA MISMA ETAPA/////////////////

  listCatalogoExiste(idSprEtapaProyecto: number) {
    for (let elemento of this.dataEtapa) {
      if (elemento.idSprEtapaProyecto == idSprEtapaProyecto) {
        this.alertService.warning(
          '¡Atención!',
          'Existe una etapa con el mismo nombre.'
        );
        return false;
      }
    }
    return true;
  }

  ///////////////TRAE DATOS DE ETAPAS/////////////////
  listDataEtapa() {
    if (this.idSprProyecto) { 
      this.etapaService.list(`?idSprProyecto=${this.idSprProyecto}`)
        .subscribe((resp) => {
          this.dataEtapa = resp;
          this.listEtapaProyectos();
        });
    }
  }
  ////////TRAE DATOS DEL CATALOGO ESPECIAL UNO ETAPA DE PROYCTO//////////////

  listEtapaProyectos() {
    this.especialUnoService.list('?spr_idSprEspecialUno=' + this.idSprEspecialUnoEtapaProyectos)
      .subscribe((resp) => {
        this.dataCatalogoEtapaProyecto = resp;
        this.mapeoEtapaProyecto();
      });
  }


  viewDataConfig(dataConfig: any){
    let nombreEtapa
    this.especialUnoService.list(dataConfig).subscribe({
      next:(resp)=>{
        nombreEtapa=resp.nombre;
       this.titulosEtapa[0].nombre = nombreEtapa;
      }
    })
  }

  ///////MAPEO DEL CATALOGO ESPECIAL UNO ETAPA DE PROYECTOS////////////////
  mapeoEtapaProyecto() {
    let dataProcess = [];
    for (let i = 0; i < this.dataEtapa.length; i++) {
      for (let j = 0; j < this.dataCatalogoEtapaProyecto.length; j++) {
        if (
          this.dataCatalogoEtapaProyecto[j].idSprEspecialUno ===
          this.dataEtapa[i].idSprEtapaProyecto
        ) {
          dataProcess.push({
            nombre: this.dataCatalogoEtapaProyecto[j].nombre + ' ' + this.dataCatalogoEtapaProyecto[j].ponderacion + '%',
            idSprEtapa: this.dataEtapa[i].idSprEtapa,
            idSprEtapaProyecto: this.dataEtapa[i].idSprEtapaProyecto,
            maximoHitos: this.dataEtapa[i].maximoHitos,
            pesoTotal: this.dataEtapa[i].pesoTotal,
            orden:this.dataEtapa[i].orden,
            fechaInicio: this.dataEtapa[i].fechaInicio,
            fechaFin: this.dataEtapa[i].fechaFin,
            estado: this.dataEtapa[i].estado,
          });
        }
      }
    }
    this.dataEtapaProyecto = dataProcess;
    this.reDrawDataTable();
  }


  delete(idRegister: number) {
    this.modal.open('borrar-etapa');
    this.idDeleteRegister = idRegister;
  }

  /////////////////VERIFICA LOS HITOS RLACIONADOS///////////////////////
  verifyHito() {
    return this.hitoService
      .list(`?idSprEtapa=${this.idDeleteRegister}&delLog=N`)
      .toPromise();
  }

  /////////////////////////////////////////////////////////////////////////

  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion = await this.verifyHito();
    dataVerifyRelacion.length > 0 ? (confirmDelete = false) : '';
    //###################################################################################
    if (confirmDelete) {
      this.etapaService
        .delete({
          idSprEtapa: this.idDeleteRegister,
          usuario: this.idSprUsuario,
          delLog: 'S',
          ip: this.ipAddress,
        })
        .subscribe(
          (resp) => {
            this.initApp();
            this.modal.closeId('borrar-etapa');
            this.alertService.deleteOk();
          },
          (err) => {
            this.alertService.deleteError();
          }
        );
    } else {
      this.alertService.warning('¡Atención!','No se puede borrar este registro por que tiene hitos relacionados.');
    }
  }

 hitoInit(obj: any) {
  this.maximoHitosEtapa = obj.maximoHitos;
  this.idEtapa = obj.idSprEtapa;
  this.hito = obj;
  this.idSprProyectoSeleccionado = obj.idSprProyecto;
  this.desripcionEtapa = obj.nombre;
  if (obj.orden === 1) {
    // Si es la primera etapa, simplemente abrimos el modal de hito
    this.openModalHito();
  } else {
    // Para las otras etapas, verificamos si se han completado los hitos de la etapa anterior
    this.etapaService.list(`?orden=${obj.orden - 1}&idSprProyecto=${this.idSprProyecto}`).subscribe({
      next:(resp) => {
        let valorMaximoHitoAnterior=resp[0].maximoHitos
        if (resp && resp.length > 0) {
          // Si hay datos de la etapa anterior, verificamos si se han completado los hitos
          this.hitoService.list(`?idSprEtapa=${resp[0].idSprEtapa}`).subscribe({
            next:(reps) => {   
              if (reps.length === valorMaximoHitoAnterior) {
                // Si se han completado los hitos, abrimos el modal para esta etapa
                this.openModalHito();
              } else {
                this.alertService.warning('¡Atención!', 'No se ha completado el máximo de hitos de la etapa anterior.');
              }
            },
            error:(error) => {
              this.alertService.error('Error', 'Error al obtener hitos');
            }
        });
        } else {
          // Si no hay datos de la etapa anterior, mostramos un mensaje de advertencia
          this.alertService.warning('¡Atención!', 'No se ha completado la etapa anterior.');
        }
      },
     error:(error) => {
        this.alertService.error('Error', 'Error al obtener la etapa anterior');
      }
  });
  }
}
  // Modal Crear/editar
  openModalHito() {
    this.onResetForm();
    this.modal.open(this.nameModal1);   
  }

  openModalEtapa() {
    this.onResetForm(), this.modal.open(this.nameModalEtapa);
  }

  openModalEtapaEdit() {
    this.onResetForm(), this.modal.open(this.editNameModalEtapa);
  }
  //#######################
  //RESETEA EL FORMULARIO//
  //#######################
  onResetForm() {
    this.formSubmitted = false;
    this.formEtapa.reset();
  }

  closeModalEtapa() {
    this.modal.closeId('etapa-hito');
  }
  closeModalEtapaEdit() {
    this.modal.closeId('editar-Etapa-hito');
  }
}
